import { getWorkingScheduleAroundTodayApi } from '../generated/master/getWorkingScheduleAroundToday';

const getScheduleAroundTodayApi = getWorkingScheduleAroundTodayApi.enhanceEndpoints({
  endpoints: {
    getWorkingScheduleAroundToday: {
      providesTags: ['ScheduleAroundToday'],
    },
  },
});

export const { useGetWorkingScheduleAroundTodayQuery } = getScheduleAroundTodayApi;
